import React, { Fragment, Suspense } from "react";
import { Helmet } from "react-helmet";
import Loader from "../../components/NewView/Common/Loader";

const LoginComponent = React.lazy(() =>
    import("../../components/NewView/RootComponents/LoginComponent")
  );
const LoginPage = () => {
  return (
    <Fragment>
      <Suspense fallback={<Loader />}>
        <Helmet>
          <title>
            YellowHub
          </title>
          <meta
            name="description"
            content="Next LMS - Professional LMS Online Education Course
            React Template"
          />
        </Helmet>
        <LoginComponent />
      </Suspense>
    </Fragment>
  );
};

export default LoginPage;
